import { useCallback, useState } from "react";

type UseModalReturn = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
};

export function useModalState(initialOpen = false): UseModalReturn {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
  };
}
